module.exports = __webpack_public_path__ + "img/officialwechat.38287c04.png";